import React from 'react'
import Article from '../components/Article'
import Layout from '../components/Layout'
import { graphql } from 'gatsby'

const ArticlePage = (props) => {
  const { pageContext, location, data } = props
  let locations = []
  if (data && data.locations) {
    locations = data.locations.edges.map(({ node }) => node)
  }
  return (
    <Layout location={location}>
      <Article article={pageContext.article} locations={locations} />
    </Layout>
  )
}

export const pageQuery = graphql`query ArticleData {
  locations: allDealershipCatfish(sort: {shortName: ASC}) {
    edges {
      node {
        _id
        slug
        shortName
      }
    }
  }
}`

export default ArticlePage
